import React from 'react';
import { DatePicker } from '@material-ui/pickers';
import { localMomentToTimeZoneStartOfTheDayDate, timeZoneToLocal } from "app/main/utils/dateUtils";

function TimeZoneDatePicker(props) {
  const callOnChange = value => {
    props.onChange && props.onChange(value);
  }
  const handleChange = value => {
    if (!value) {
      callOnChange(null);
    }
    return callOnChange(localMomentToTimeZoneStartOfTheDayDate(value));
  }
  return (
    <DatePicker
      inputVariant="outlined"
      format="MM/DD/yyyy"
      { ...props }
      value={timeZoneToLocal(props.value)}
      onChange={handleChange}
    />
  )
}
export default TimeZoneDatePicker;
